import i18n from '@/i18n'
import Store from '@/store'
import ReportHeading from '@/Utils/report-head'
import pdfMake from 'pdfmake/build/pdfmake'
import pdfFontsBn from 'pdfmake/build/vfs_fonts_bn'
import pdfFontsEn from 'pdfmake/build/vfs_fonts_en'

const exportPdfDetails = async (baseUrl, uri = '/report-heading/detail', orgId, reportTitle, data, vm, titleData) => {
    try {
      Store.commit('mutateCommonProperties', {
        loading: true
      })

      if (i18n.locale === 'bn') {
        pdfMake.vfs = pdfFontsBn.pdfMake.vfs
      } else {
        pdfMake.vfs = pdfFontsEn.pdfMake.vfs
      }

      const reportHeadData = await ReportHeading.getReportHead(baseUrl, uri, orgId)
      const pdfContent = []

      pdfContent.push(
        {
          table: {
            style: 'tableData',
            headerRows: 0,
            widths: ['25%', '50%', '25%'],
            body: [
              [
                {},
                { image: reportHeadData.reportHeadColumn[2].image, height: 50, width: 50, alignment: 'center' },
                {}
              ],
              [
                { image: reportHeadData.reportHeadColumn[0].image, height: 50, width: 50, alignment: 'center', rowSpan: 5 },
                { text: vm.$t('production_store.govt_info'), style: 'govt_info', alignment: 'center' },
                { image: reportHeadData.reportHeadColumn[1].image, height: 50, width: 50, alignment: 'center', rowSpan: 5 }
              ],
              [
                {},
                { text: reportHeadData.orgName, style: 'header2', alignment: 'center' },
                {}
              ],
              [
                {},
                { text: reportHeadData.heading, style: 'address', alignment: 'center' },
                {}
              ],
              [
                {},
                { text: reportHeadData.address, style: 'address', alignment: 'center' },
                {}
              ],
              [
                {},
                {},
                {}
              ]
            ]
          },
          layout: {
            hLineWidth: function (i, node) {
              return 0
            },
            vLineWidth: function (i, node) {
              return 0
            }
          }
        }
      )

      pdfContent.push(
        { text: reportTitle, style: 'header', alignment: 'center', decoration: 'underline' }
      )

      pdfContent.push(
        {
          table: {
            style: 'tableData',
            headerRows: 0,
            widths: ['25%', '25%'],
            body: [
                [
                  { },
                  { }
                ],
              [
                { text: vm.$t('globalTrans.division') + ': ' + (titleData.division ? (titleData.division) : vm.$t('globalTrans.all')), style: 'td', alignment: 'left' },
                { text: vm.$t('globalTrans.district') + ': ' + (titleData.district ? (titleData.district) : vm.$t('globalTrans.all')), style: 'td', alignment: 'right' }
              ]
            ]
          },
          layout: {
              hLineWidth: function (i, node) {
                return 0
              },
              vLineWidth: function (i, node) {
                return 0
              }
            }
        }
      )

      // Primary Loop
      for (let indexA = 0; indexA < data.length; indexA++) {
        const primary = data[indexA]

        const allRowsHead = [
          [
            { text: `${vm.$t('globalTrans.district')} : ${vm.getDistrictName(primary.district_id)}`, style: 'th', alignment: 'left', colSpan: 4 },
            {},
            {},
            {}
          ],
          [
            { text: vm.$t('globalTrans.sl_no'), style: 'th', alignment: 'center' },
            { text: vm.$t('application_management.registered_organization'), style: 'th', alignment: 'left' },
            { text: vm.$t('performance_monitoring.address'), style: 'th', alignment: 'left', colSpan: 2 },
            { }
          ]
        ]

        // Secondary Loop
        for (let index = 0; index < primary.items.length; index++) {
          const report = primary.items[index]
          allRowsHead.push(
          [
            { text: vm.$n(index + 1), style: 'td', alignment: 'center' },
            { text: vm.$i18n.locale === 'bn' ? report.org_bn : report.org, style: 'td', alignment: 'left' },
            { text: vm.$i18n.locale === 'bn' ? report.address_bn : report.address_en, style: 'td', alignment: 'left', colSpan: 2 },
            { }
          ])
        }

        /**
         * From start to second last
         */
        if (indexA < (data.length - 1)) {
          allRowsHead.push([
            { text: `${vm.$t('report_management.dis_total_org')} : ${vm.$n(primary.count)}`, style: 'td', alignment: 'left', colSpan: 4 },
            {},
            {},
            {}
          ])

          pdfContent.push({
            table: {
              headerRows: 1,
              widths: ['10%', '*', '*', '*'],
              body: allRowsHead
            }
          })

          pdfContent.push(
            { text: '', style: 'empty_space' }
          )
        } else {
          /**
           * Last Item for Grand Total
           */
           allRowsHead.push([
            { text: `${vm.$t('report_management.dis_total_org')} : ${vm.$n(primary.count)}`, style: 'td', alignment: 'left', colSpan: 4 },
            {},
            {},
            { }
          ])
          if (titleData.district_id === 0) {
            allRowsHead.push([
              { text: `${vm.$t('report_management.divi_total_org')} : ${vm.$n(vm.grand_count)}`, style: 'td', alignment: 'left', colSpan: 4 },
              { },
              {},
              {}
            ])
          }

          pdfContent.push({
            table: {
              headerRows: 1,
              widths: ['10%', '*', '*', '*'],
              body: allRowsHead
            }
          })

          pdfContent.push(
            { text: '', style: 'empty_space' }
          )
        }
      }

      var docDefinition = {
        content: pdfContent,
        pageSize: 'A4',
        pageOrientation: 'portrait',
        styles: {
          th: {
            fillColor: '#dee2e6',
            fontSize: 10,
            margin: [3, 3, 3, 3]
          },
          th1: {
              fontSize: 9
            },
          td: {
            fontSize: 10,
            margin: [3, 3, 3, 3]
          },
          td2: {
              border: 0,
              fontSize: 10,
              alignment: 'center'
            },
          header: {
            margin: [0, 10, 0, 10],
            fontSize: 14,
            alignment: 'center'
          },
          header2: {
            border: 0,
            fontSize: 14,
            margin: [0, 0, 0, 1]
          },
          govt_info: {
            margin: [0, 1, 0, 1],
            fontSize: 15,
            alignment: 'center'
          },
          address: {
            border: 0,
            fontSize: 10,
            bold: true,
            margin: [0, 0, 0, 1]
          },
          left_logo: {
            borderRadius: 50
          },
          empty_space: {
            margin: [10, 10, 10, 10]
          }
        }
      }

      pdfMake.createPdf(docDefinition, null, null, null).print()
    } catch (error) {
      if (error) {
      }
    }

    Store.commit('mutateCommonProperties', {
      loading: false
    })
}

export default {
  exportPdfDetails
}
